import React, { useContext, useState } from "react";

export default function Loader() {


    return (

        <div className="loadingContainer performance-search-loader">
            <div className="loadingSpinner"></div>
        </div>

    );
}